import RadioGroupField from 'components/forms/radioGroupField/RadioGroupField';
import { Trans, useTranslation } from 'react-i18next';
import { Col } from 'react-bootstrap';
import TextField from 'components/forms/textField/TextField';
import { useWatch } from 'react-hook-form';
import { FeeConditionEnum } from 'models/PropertyFees';
import SelectField from 'components/forms/selectField/SelectField';
import {
  ConditionContainer,
  NightFieldContainer,
} from './PropertyFeeModal.styles';
import { BY_LENGTH_OF_STAY_SCOPE_OPTION } from './PropertyFeeModal.constants';

interface Option {
  value: string | number;
  label: string;
}

const TaxConditionField = ({
  labelInputSizes,
  conditionByLengthOfStayOptions,
  conditionTypeOptions,
  conditionByNightOptions,
}: {
  conditionByLengthOfStayOptions: Option[];
  conditionTypeOptions: Option[];
  conditionByNightOptions: Option[];
  labelInputSizes: {
    colSmLabel: number;
    colSmInput: number;
  };
}) => {
  const { t } = useTranslation();
  const conditionType = useWatch({ name: 'tax.conditions.type' });

  const isByLengthOfStayCondition =
    conditionType === BY_LENGTH_OF_STAY_SCOPE_OPTION;
  const isByNightCondition = conditionType === FeeConditionEnum.BY_NIGHT;

  return (
    <ConditionContainer>
      <RadioGroupField
        name="tax.conditions.type"
        label={t(
          'pageProperty.feesTaxesAndPolicies.propertyFeesAndTaxes.addModal.condition',
        )}
        required
        {...labelInputSizes}
        options={conditionTypeOptions}
      />

      {isByLengthOfStayCondition && (
        <>
          <Col className="col-md-offset-5">
            <RadioGroupField
              name="tax.conditions.lengthOfStayType"
              horizontal
              options={conditionByLengthOfStayOptions}
              {...labelInputSizes}
            />
          </Col>

          <Col xs={8} className="col-md-offset-4">
            <TextField
              name="tax.conditions.lengthOfStayValue"
              label={t(
                'pageProperty.feesTaxesAndPolicies.propertyFeesAndTaxes.addModal.forStaysOver',
              )}
              type="number"
              min={1}
              rightAddons={[
                t(
                  'pageProperty.feesTaxesAndPolicies.propertyFeesAndTaxes.addModal.nights',
                ),
              ]}
              required
              {...labelInputSizes}
            />
          </Col>
        </>
      )}

      {isByNightCondition && (
        <Col xs={12} md={7} className="col-md-offset-4">
          <NightFieldContainer>
            <Trans
              i18nKey="pageProperty.feesTaxesAndPolicies.propertyFeesAndTaxes.addModal.appliesUpToNights"
              components={{
                select: (
                  <SelectField
                    name="tax.conditions.firstNightsApplying"
                    options={conditionByNightOptions}
                  />
                ),
              }}
            />
          </NightFieldContainer>
        </Col>
      )}
    </ConditionContainer>
  );
};

export default TaxConditionField;
